var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterArrowUpNoBorderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99965 15C8.13226 15 8.25944 14.9473 8.35321 14.8536C8.44698 14.7598 8.49965 14.6326 8.49965 14.5V2.707L11.6457 5.854C11.7395 5.94789 11.8669 6.00063 11.9997 6.00063C12.1324 6.00063 12.2598 5.94789 12.3537 5.854C12.4475 5.76011 12.5003 5.63278 12.5003 5.5C12.5003 5.36722 12.4475 5.23989 12.3537 5.146L8.35365 1.146C8.30721 1.09944 8.25203 1.06249 8.19129 1.03729C8.13054 1.01208 8.06542 0.999106 7.99965 0.999106C7.93389 0.999106 7.86877 1.01208 7.80802 1.03729C7.74728 1.06249 7.6921 1.09944 7.64565 1.146L3.64565 5.146C3.55177 5.23989 3.49902 5.36722 3.49902 5.5C3.49902 5.63278 3.55177 5.76011 3.64565 5.854C3.73954 5.94789 3.86688 6.00063 3.99966 6.00063C4.13243 6.00063 4.25977 5.94789 4.35366 5.854L7.49965 2.707V14.5C7.49965 14.6326 7.55233 14.7598 7.6461 14.8536C7.73987 14.9473 7.86705 15 7.99965 15Z",
    fill: "#00948B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterArrowUpNoBorderIcon);
export default __webpack_public_path__ + "static/media/filter-arrow-up-no-border-icon.688e91636d6c7edf48b0488f2ac3b6ba.svg";
export { ForwardRef as ReactComponent };